import { atom } from 'jotai';

export const showCompleteWorksheetAtom = atom(false);
export const clickFloatingButtonAtom = atom(false);
export const resetDiscussQuestionAtom = atom(false); // to allow opening a Minichat upon clicking the floating button
export const stateOnboardingTooltipAtom = atom(0); // to identify 0 = haven't show onboarding tooltip; 1 = already show onboarding tooltip -> go to onboarding mastery popup
export const permissionShowOnboardingTooltip = atom(false); // to check if student already pass 14 day after account creation or not, checking happen in getOnboardingTooltipPermission
export const showGenieAskFloatingButtonAtom = atom<boolean>(true); // to show GenieAsk floating button that is currently shown in Worksheet Dashboard and GenieClass Dashboard
